import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterByField'
})
export class FilterByFieldPipe implements PipeTransform {

  transform(items: any[] | undefined, field: string, value: any, differentThanValue?: boolean | undefined): any[] {

    if (!items) {
      return [];
    }
    if (!field) {
      return items;
    }

    const filteredItems = items.filter(item => {
      if (differentThanValue) {
        return item[field] !== value
      }
      return item[field] === value
    });
    return filteredItems ?? [];
  }
}
